import { render, staticRenderFns } from "./PatientListView.vue?vue&type=template&id=680a613c&scoped=true"
import script from "./PatientListView.vue?vue&type=script&lang=js"
export * from "./PatientListView.vue?vue&type=script&lang=js"
import style0 from "./PatientListView.vue?vue&type=style&index=0&id=680a613c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a613c",
  null
  
)

export default component.exports